// extracted by mini-css-extract-plugin
module.exports = {"mobile":"Logo_mobile__9rNCj","small":"Logo_small__2pmVy","medium":"Logo_medium__3lnkY","large":"Logo_large__2nKOZ","white":"Logo_white__2UVZV","primary":"Logo_primary__3DOOI"};